import { useParams, useSearchParams } from "react-router-dom";
import NotFoundPage from "src/shared/features/errorPages/NotFound";
import { FormAvailablePagesType } from "./types";
import { formComponents } from "./PathToPageComponentMapper";
import { useFormAccessValidation } from "./useFormAccessValidation";
import NotAuthorizedPage from "src/shared/features/errorPages/NotAuthorizedPage";

/**
 * This component renders the correct page of the form based on the path
 * it discovers the appTypeId from the url and then renders the correct page
 * Either the id is as a param e.g. /application/21/form
 * or as a query param e.g. /application/form?appTypeId=21
 */
const FormPageRenderer = ({ path }: { path: FormAvailablePagesType }) => {
  const [searchParams] = useSearchParams();
  const { id } = useParams();

  // Determine the formId from the url either it comes from the params or the query params
  const formId = id || searchParams.get("appTypeId");

  if (!formId) return <NotFoundPage />;

  const { hasAccess } = useFormAccessValidation();

  if (!hasAccess) {
    return <NotAuthorizedPage />;
  }

  // get the selected form from the formComponents
  const selectedForm = formComponents[formId];

  if (!selectedForm) {
    return <NotFoundPage />;
  }
  const selectedComponent = selectedForm[path] || <NotFoundPage />;

  return selectedComponent;
};

export default FormPageRenderer;
